﻿{
  "WebAppUrl": "https://eatec-mobileui-dev.rguest.com/EatecApplication.zip",
  "App_CurrentVersion": "26.3.2",
  "App_MinVersion": "26.3.2",
  "App_Size": "15MB",
  "Features": [ "featuresdesc" ],
  "Api_Url": "https://aks-eatec-apigateway-devint.rguest.com",
  "AdData": null,
   "EnableProductAuthentication": true,
   "B2CLoginUserFlow": null,
   "TenantIdentifier": "idcbyu",
  "DefaultLanguageCode": "en-US"
}
